import React, {Component} from 'react';
import QuizParams from './QuizParams';
import Parameters from "../common/Parameters";
import CircularProgress from "@material-ui/core/CircularProgress";
import Overlay from "../anketa/Overlay";
import Translation from "../common/Translation";
import RadioInput from './RadioInput';
import AnswerButton from './AnswerButton';

export default class Quiz  extends Component {

    constructor() {
        super();
        const parameters = new Parameters();
        this.member_reg_code = parameters.getMemberId();
        this.eventId = parameters.getEventId();
        this.lang = parameters.getLang();

        this.quizResult = {};

        this.state = {
            messages: this.getMessages(),
            displayOverlay: false,
            overlayText: "",
            event_name: "",
            logo: "",
            questions: [],
            questionNum: 0
        };

        this.onAnswerQuestion = this.onAnswerQuestion.bind(this);
        this.onChangeAnswer = this.onChangeAnswer.bind(this);
    }

    getMessages() {
        return {
            ["Опрос учасников"]:"Опитування учасників",
            ["Я уже отвечал"]:"Я вже відповідав",
            ["Отправить"]:"Відправити",
            ["Ответить"]:"Відповісти",
            ["Спасибо за участие в опросе!"]:"Дякуємо за участь в опитуванні!",
            ["Вернуться на страницу вебинара"]: "Повернутись на сторінку вебінару"
        };
    }

    getTitle() {
        return this.state.messages["Опрос учасников"];
    }

    getAlreadyAnswered() {
        return this.state.messages["Я уже отвечал"];
    }

    onChangeAnswer(e) {
        const inputName = this.state.questions[this.state.questionNum].name;
        this.quizResult[inputName]=e.target.value;
    }

    onAnswerQuestion(e) {
        if(e) {
            e.preventDefault();
        }

        if(this.state.questionNum < this.state.questions.length) {
            this.setState({
                ...this.state,
                questionNum: this.state.questionNum+1
            });
            return false;
        }
    }

    getFormParameters() {
        QuizParams.get(this.member_reg_code, this.eventId, this.lang, (quiz) => {
            QuizParams.paramNames().forEach((name) => {
                let state = this.state;
                state[name] = quiz.hasOwnProperty(name)
                    ? quiz[name]
                    : '';

                this.setState({
                    ...state
                });
            });

        }, (error) => {
            this.setState({error: error})
        });
    }

    componentDidMount() {
        let phrases = [];
        for(let message in this.state.messages) {
            phrases.push(message);
        }

        Translation.translate(phrases, this.lang, (translation) => {
                // console.log("-----");
                // console.log(translation);
                // console.log("-----");

                const state=this.state;
                state.messages=translation;

                this.setState({...state});
            }, () => {
                // this.setDefaultMessage();
            },
            this.eventId
        );

        this.getFormParameters();

    }

    onAlreadyRegisteredClick() {
        alert("Already answered");
    }

    getForm() {

        if(this.state.questionNum >= this.state.questions.length) {
            // Post results
            QuizParams.saveResult(this.member_reg_code, this.eventId, this.quizResult);

            const webinarUrl = `/index.html?id=${this.member_reg_code}&p=remote&op=show&event_id=${this.eventId}&lang=${this.lang}`;
            return (
                <React.Fragment>
                    <h3>
                        {this.state.messages["Спасибо за участие в опросе!"]}
                    </h3>
                    <b>
                        <a href={webinarUrl}>{this.state.messages["Вернуться на страницу вебинара"]}</a>
                    </b>
                </React.Fragment>
            );
        }

        const q = this.state.questions[this.state.questionNum];

        return (
            <React.Fragment>
                <form className="registration-quiz" onChange={this.onChangeAnswer}>
                    <RadioInput name={q.name} options={q.options} question={q.question}/>
                    <AnswerButton click={this.onAnswerQuestion} message={this.state.messages["Ответить"]} time={q.time}/>
                </form>
            </React.Fragment>
        );
    }

    render() {
        if(this.state.questions.length === 0) {
            return (<CircularProgress/>);
        }

        document.body.classList.add('registration-bg');

        return (
            <div>
                <div className="registration">
                    <div className="anketa-form-div">
                        <img src={this.state.logo} alt={this.state.event_name}/>
                        <div className="registration-quiz">{this.getTitle()}</div>
                        <div style={{marginTop: '10px'}}>
                        {this.getForm()}
                        </div>
                    </div>
                </div>

                {/*<Overlay display={this.state.displayOverlay} text={this.state.overlayText} closeCb={this.hideOverlay}/>*/}

            </div>
        );
    }
}
